export const GET_AMLS_TM_COMMON_TRANSACTION_HISTORY =
  'GET_AMLS_TM_COMMON_TRANSACTION_HISTORY';
export const GET_AMLS_TM_COMMON_TRANSACTION_HISTORY_SUCCESS =
  'GET_AMLS_TM_COMMON_TRANSACTION_HISTORY_SUCCESS';
export const GET_AMLS_TM_COMMON_TRANSACTION_HISTORY_FAIL =
  'GET_AMLS_TM_COMMON_TRANSACTION_HISTORY_FAIL';

export const DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY =
  'DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY';
export const DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY_SUCCESS =
  'DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY_SUCCESS';
export const DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY_FAIL =
  'DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY_FAIL';

export const GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES =
  'GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES';
export const GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES_SUCCESS =
  'GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES_SUCCESS';
export const GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES_FAIL =
  'GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES_FAIL';

export const GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS =
  'GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS';
export const GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS_SUCCESS =
  'GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS_SUCCESS';
export const GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS_FAIL =
  'GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS_FAIL';

export const GET_SCORE_EXPLAINABLITY = 'GET_SCORE_EXPLAINABLITY';
export const GET_SCORE_EXPLAINABLITY_SUCCESS =
  'GET_SCORE_EXPLAINABLITY_SUCCESS';
export const GET_SCORE_EXPLAINABLITY_FAIL = 'GET_SCORE_EXPLAINABLITY_FAIL';

export const GET_PEER_AND_PROFILE_GRAPH = 'GET_PEER_AND_PROFILE_GRAPH';
export const GET_PEER_AND_PROFILE_GRAPH_SUCCESS =
  'GET_PEER_AND_PROFILE_GRAPH_SUCCESS';
export const GET_PEER_AND_PROFILE_GRAPH_FAIL =
  'GET_PEER_AND_PROFILE_GRAPH_FAIL';

export const GET_TYPOLOGY_LIST = 'GET_TYPOLOGY_LIST';
export const GET_TYPOLOGY_LIST_SUCCESS = 'GET_TYPOLOGY_LIST_SUCCESS';
export const GET_TYPOLOGY_LIST_FAIL = 'GET_TYPOLOGY_LIST_FAIL';

export const GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID =
  'GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID';
export const GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID_SUCCESS =
  'GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID_SUCCESS';
export const GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID_FAIL =
  'GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID_FAIL';

export const GET_PREVENTION_SCORE_EXPLAINABLITY =
  'GET_PREVENTION_SCORE_EXPLAINABLITY';
export const GET_PREVENTION_SCORE_EXPLAINABLITY_SUCCESS =
  'GET_PREVENTION_SCORE_EXPLAINABLITY_SUCCESS';
export const GET_PREVENTION_SCORE_EXPLAINABLITY_FAIL =
  'GET_PREVENTION_SCORE_EXPLAINABLITY_FAIL';

export const GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS =
  'GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS';
export const GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_SUCCESS =
  'GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_SUCCESS';
export const GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_FAIL =
  'GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_FAIL';

export const DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS =
  'DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS';
export const DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_SUCCESS =
  'DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_SUCCESS';
export const DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_FAIL =
  'DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_FAIL';

export function getAMLSTMCommonTransactionHistory(payload) {
  return {
    type: GET_AMLS_TM_COMMON_TRANSACTION_HISTORY,
    payload
  };
}

export function getAMLSTMCommonTransactionHistorySuccess(payload) {
  return {
    type: GET_AMLS_TM_COMMON_TRANSACTION_HISTORY_SUCCESS,
    payload
  };
}

export function getAMLSTMCommonTransactionHistoryFail(payload) {
  return {
    type: GET_AMLS_TM_COMMON_TRANSACTION_HISTORY_FAIL,
    payload
  };
}

export function downloadAMLSTMCommonTransactionHistory(payload) {
  return {
    type: DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY,
    payload
  };
}

export function downloadAMLSTMCommonTransactionHistorySuccess(payload) {
  return {
    type: DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY_SUCCESS,
    payload
  };
}

export function downloadAMLSTMCommonTransactionHistoryFail(payload) {
  return {
    type: DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY_FAIL,
    payload
  };
}

export function getAMLSTMCommonTransactionTriggeredTypologies(payload) {
  return {
    type: GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES,
    payload
  };
}

export function getAMLSTMCommonTransactionTriggeredTypologiesSuccess(payload) {
  return {
    type: GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES_SUCCESS,
    payload
  };
}

export function getAMLSTMCommonTransactionTriggeredTypologiesFail(payload) {
  return {
    type: GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES_FAIL,
    payload
  };
}

export function getAMLSTMCommonTransactionTriggeredVariants(payload) {
  return {
    type: GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS,
    payload
  };
}

export function getAMLSTMCommonTransactionTriggeredVariantsSuccess(payload) {
  return {
    type: GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS_SUCCESS,
    payload
  };
}

export function getAMLSTMCommonTransactionTriggeredVariantsFail(payload) {
  return {
    type: GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS_FAIL,
    payload
  };
}

export function getScoreExplainablity(payload) {
  return {
    type: GET_SCORE_EXPLAINABLITY,
    payload
  };
}

export function getScoreExplainablitySuccess(payload) {
  return {
    type: GET_SCORE_EXPLAINABLITY_SUCCESS,
    payload
  };
}

export function getScoreExplainablityFail(payload) {
  return {
    type: GET_SCORE_EXPLAINABLITY_FAIL,
    payload
  };
}

export function getPeerAndProfileGraph(payload) {
  return {
    type: GET_PEER_AND_PROFILE_GRAPH,
    payload
  };
}

export function getPeerAndProfileGraphSuccess(payload) {
  return {
    type: GET_PEER_AND_PROFILE_GRAPH_SUCCESS,
    payload
  };
}

export function getPeerAndProfileGraphFail(payload) {
  return {
    type: GET_PEER_AND_PROFILE_GRAPH_FAIL,
    payload
  };
}

export function getTypologyList(payload) {
  return {
    type: GET_TYPOLOGY_LIST,
    payload
  };
}

export function getTypologyListSuccess(payload) {
  return {
    type: GET_TYPOLOGY_LIST_SUCCESS,
    payload
  };
}

export function getTypologyListFail(payload) {
  return {
    type: GET_TYPOLOGY_LIST_FAIL,
    payload
  };
}

export function getRiskIndicatorListByTypologyId(payload) {
  return {
    type: GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID,
    payload
  };
}

export function getRiskIndicatorListByTypologyIdSuccess(payload) {
  return {
    type: GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID_SUCCESS,
    payload
  };
}

export function getRiskIndicatorListByTypologyIdFail(payload) {
  return {
    type: GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID_FAIL,
    payload
  };
}

export function getAmlsCommonPreventionScoreExplainablity(payload) {
  return {
    type: GET_PREVENTION_SCORE_EXPLAINABLITY,
    payload
  };
}

export function getAmlsCommonPreventionScoreExplainablitySuccess(payload) {
  return {
    type: GET_PREVENTION_SCORE_EXPLAINABLITY_SUCCESS,
    payload
  };
}

export function getAmlsCommonPreventionScoreExplainablityFail(payload) {
  return {
    type: GET_PREVENTION_SCORE_EXPLAINABLITY_FAIL,
    payload
  };
}

export function getAMLSTMCommonCustomerLoanDetails(payload) {
  return {
    type: GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS,
    payload
  };
}

export function getAMLSTMCommonCustomerLoanDetailsSuccess(payload) {
  return {
    type: GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_SUCCESS,
    payload
  };
}

export function getAMLSTMCommonCustomerLoanDetailsFail(payload) {
  return {
    type: GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_FAIL,
    payload
  };
}

export function downloadAMLSTMCommonCustomerLoanDetails(payload) {
  return {
    type: DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS,
    payload
  };
}

export function downloadAMLSTMCommonCustomerLoanDetailsSuccess(payload) {
  return {
    type: DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_SUCCESS,
    payload
  };
}

export function downloadAMLSTMCommonCustomerLoanDetailsFail(payload) {
  return {
    type: DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS_FAIL,
    payload
  };
}

export const GET_AMLS_TM_COMMON_TRANSACTION_TYPES_FILTER =
  'GET_AMLS_TM_COMMON_TRANSACTION_TYPES_FILTER';
export const GET_AMLS_TM_COMMON_TRANSACTION_TYPES_FILTER_SUCCESS =
  'GET_AMLS_TM_COMMON_TRANSACTION_TYPES_FILTER_SUCCESS';
export const GET_AMLS_TM_COMMON_TRANSACTION_TYPES_FILTER_FAIL =
  'GET_AMLS_TM_COMMON_TRANSACTION_TYPES_FILTER_FAIL';

export function getAMLSTMCommonTransactionTypesFilter(payload) {
  return {
    type: GET_AMLS_TM_COMMON_TRANSACTION_TYPES_FILTER,
    payload
  };
}

export function getAMLSTMCommonTransactionTypesFilterSuccess(payload) {
  return {
    type: GET_AMLS_TM_COMMON_TRANSACTION_TYPES_FILTER_SUCCESS,
    payload
  };
}

export function getAMLSTMCommonTransactionTypesFilterFail(payload) {
  return {
    type: GET_AMLS_TM_COMMON_TRANSACTION_TYPES_FILTER_FAIL,
    payload
  };
}
